import React from 'react';
import GeneralButton from '../../../../../Components/GeneralButton';
import { Box } from '@mui/material';

import { ACCESS_CONTROL_CONSTANTS } from '../../../../../core/constants';
const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

const CreateVideoSectionWithdefaultValues = ({ createVideoSection }) => {
	return (
		<Box style={{ display: 'flex', justifyContent: 'center' }}>
			<GeneralButton
				system={SYSTEMS.FVP_PLAYER}
				name="FVP_CREATE_NEW_VIDEO_SECTION_ID_BTN"
				variant="contained"
				onClick={createVideoSection}
			>
				Create
			</GeneralButton>
		</Box>
	);
};

export default CreateVideoSectionWithdefaultValues;
